import { render, staticRenderFns } from "./DashModalBuy.vue?vue&type=template&id=317d91ec&scoped=true"
import script from "./DashModalBuy.vue?vue&type=script&lang=js"
export * from "./DashModalBuy.vue?vue&type=script&lang=js"
import style0 from "./DashModalBuy.vue?vue&type=style&index=0&id=317d91ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317d91ec",
  null
  
)

export default component.exports